import React from 'react';
import {WIDGETS} from '../../../../constants/common';
import { toTitleCase } from '../../../../helpers/helper';

export default function ThankyouPage(props){
    const userFirstName = props.userObj.details.firstName && toTitleCase(props.userObj.details.firstName);
    return(
        <div className="thankyou-container">
            <div className="header-title" data-widget-name={WIDGETS.FAQ} data-text-color="color_25">
                <div className="header-light">{props.translations.data["THANKYOU.TEXT"]}{(userFirstName !== "" && userFirstName !== "!") ? ',' : ''} <span className="userName">{userFirstName}!</span></div>
                <div className="header-bold">{props.translations.data["THANKYOU.SUB_TEXT"]}</div>
                <div className="header-light">{props.translations.data["THANKYOU.CLOSE_MESSAGE"]}</div>
            </div>
        </div>
    )
}